import modals from '../modal'

export default (function() {
  'use strict';

  let partnerData;
  let recycleDenimModal;
  let recycleDenimModalTriggers;
  const recycleDenimGrid = document.querySelector('.partners-grid')

  function showRecycleDenimDetail(recycleDenimUri) {

    const recycleDenimMemberDetails = partnerData[recycleDenimUri]
    const recycleDenimDetailsContainer = recycleDenimModal.element

    const logoElem = recycleDenimDetailsContainer.querySelector('[data-partner-logo]')
    const datesElem = recycleDenimDetailsContainer.querySelector('[data-partner-dates]')
    const howElem = recycleDenimDetailsContainer.querySelector('[data-partner-how]')
    const dealElem = recycleDenimDetailsContainer.querySelector('[data-partner-deal]')
    const linkElem = recycleDenimDetailsContainer.querySelector('[data-partner-link]')
    const restrictionsElem = recycleDenimDetailsContainer.querySelector('[data-partner-restrictions]')
    const galleryElems = recycleDenimDetailsContainer.querySelector('[data-partner-detail-gallery]')

    logoElem.src = recycleDenimMemberDetails.logoLight.url
    datesElem.innerHTML = recycleDenimMemberDetails.date
    howElem.innerHTML = recycleDenimMemberDetails.how
    dealElem.innerHTML = recycleDenimMemberDetails.deal
    linkElem.href = recycleDenimMemberDetails.storeLink
    restrictionsElem.innerHTML = recycleDenimMemberDetails.restrictions

    let galleryItems = recycleDenimMemberDetails.gallery
    if(galleryItems.length > 0){
      if(recycleDenimDetailsContainer.classList.contains('no-gallery')){
        recycleDenimDetailsContainer.classList.remove('no-gallery');
      }
      console.log(galleryElems)
      galleryItems.forEach((gallery) => {
        if(gallery.image_or_video = 'image' && gallery.image != false){
          galleryElems.innerHTML += `<img src=` + gallery.image.url + ` class="u-object-fit-cover-100%" />`
        } else{
          galleryElems.innerHTML += `<video src=` + gallery.video + ` muted loop playsinline autoplay class="u-object-fit-cover-100%" ></video>`
        }
      })
    } else {
      recycleDenimDetailsContainer.classList.add('no-gallery')
    }


  }

  function clearRecycleDenimDetail() {
    const recycleDenimDetailsContainer = recycleDenimModal.element

    const logoElem = recycleDenimDetailsContainer.querySelector('[data-partner-logo]')
    const datesElem = recycleDenimDetailsContainer.querySelector('[data-partner-dates]')
    const howElem = recycleDenimDetailsContainer.querySelector('[data-partner-how]')
    const dealElem = recycleDenimDetailsContainer.querySelector('[data-partner-deal]')
    const linkElem = recycleDenimDetailsContainer.querySelector('[data-partner-link]')
    const restrictionsElem = recycleDenimDetailsContainer.querySelector('[data-partner-restrictions]')
    const galleryElems = recycleDenimDetailsContainer.querySelector('[data-partner-detail-gallery]')

    datesElem.innerHTML = ''
    howElem.innerHTML = ''
    dealElem.innerHTML = ''
    linkElem.href = ''
    restrictionsElem.innerHTML = ''
    logoElem.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

    galleryElems.innerHTML = ''
  }

  function handleRecycleDenimTriggerClick(event) {
    event.preventDefault()
    console.log(event.target)
    showRecycleDenimDetail(event.target.dataset.recycleDenimUri)
    recycleDenimModal.open(event.target)
  }

  function setupRecycleDenimGrid() {
    partnerData = JSON.parse(document.getElementById('RecycleDenimData').textContent.trim())
    console.log(partnerData)
    Object.keys(partnerData).forEach(function(key) {

      preloadImage(partnerData[key].gallery)
    })

    recycleDenimModalTriggers = [...recycleDenimGrid.querySelectorAll('.js-recycle-denim-detail-trigger')]
    recycleDenimModal = modals.getById('modal-partner-detail')

    recycleDenimModalTriggers.forEach((trigger) => {
      trigger.addEventListener('click', handleRecycleDenimTriggerClick)
    })

    recycleDenimModal.element.addEventListener('close', handleModalClose)

  }

  function handleModalClose() {
    clearRecycleDenimDetail()
  }


  function preloadImage(url) {
    var img = new Image();
    img.src = url;
  }

  var videos = document.querySelectorAll(".zappos-video");

function checkScroll() {
    var fraction = 0.8; // Play when 80% of the player is visible.

    for(var i = 0; i < videos.length; i++) {

        var video = videos[i];

        var x = video.offsetLeft, y = video.offsetTop, w = video.offsetWidth, h = video.offsetHeight, r = x + w, //right
            b = y + h, //bottom
            visibleX, visibleY, visible;

            visibleX = Math.max(0, Math.min(w, window.pageXOffset + window.innerWidth - x, r - window.pageXOffset));
            visibleY = Math.max(0, Math.min(h, window.pageYOffset + window.innerHeight - y, b - window.pageYOffset));

            visible = visibleX * visibleY / (w * h);

            if (visible > fraction) {
                video.play();
            } else {
                video.pause();
            }

    }

}


  function init() {
    if (!recycleDenimGrid) {
      return;
    }

    window.addEventListener('scroll', checkScroll, false);
    window.addEventListener('resize', checkScroll, false);

    window.addEventListener('DOMContentLoaded', () => {
      setupRecycleDenimGrid()
    })
  }

  return {
    init,
  }

})();
